import React from "react";

import {
  ChartData,
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  PointElement,
  RadialLinearScale,
  Tooltip,
} from "chart.js";
import { Radar } from "react-chartjs-2";

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

interface GraphProps {
  labels: string[];
  data: ChartData<"radar", number[], string>["datasets"];
  options: any;
}

export default function Graph(props: GraphProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "500px",
      }}
    >
      <Radar
        data={{ labels: props.labels, datasets: props.data }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          animation: false,
          ...props.options,
        }}
      />
    </div>
  );
}
